import React from 'react';
import { Route } from 'react-router-dom';

import { FormMode } from '../Admin/constants/constants';
import { routes } from './routes/routes';
import withAuthentication from 'Components/withAuthentication';
import AppSwitch from 'Components/AppSwitch';

import NavbarLocal from 'Components/Admin/NavbarLocal';
import TabProjects from './tabs/TabProjects/TabProjects';
import ProjectForm from './tabs/ProjectForm/ProjectForm';

const Projects = ({ match: { path } }) => {
  return (
    <div className="projects admin-page" data-testid="projects-tab">
      <NavbarLocal routes={routes} />
      <AppSwitch>
        <Route path={path} exact render={(props) => <TabProjects {...props}/>} />
        <Route path={`${path}create/`} render={(props) => <ProjectForm mode={FormMode.CREATE} {...props} />} />
        <Route path={`${path}update/:id/`} render={(props) => <ProjectForm mode={FormMode.UPDATE} {...props} />} />
      </AppSwitch>
    </div>
  );
};

export default withAuthentication(Projects);
